export const isUndefined = (value: any) => typeof value === 'undefined'

export const isEmpty = (value: any) =>
  isUndefined(value) || (typeof value === 'string' && !value.length)

export const formatAmount = (
  value: string | number,
  separator: string = ' '
) => {
  const [total, decimal] = `${parseFloat(`${value}`).toFixed(2)}`.split('.')
  const parsedTotal = total
    .split('')
    .reverse()
    .reduce(
      (prev, next, idx) => `${prev}${next}${(idx + 1) % 3 ? '' : separator}`,
      ''
    )
    .split('')
    .reverse()
    .join('')

  return decimal ? `${parsedTotal}.${decimal}` : parsedTotal
}

export const copyTextToClipboard = async (text: string) => {
  if ('clipboard' in navigator) {
    return await navigator.clipboard.writeText(text)
  } else {
    return document.execCommand('copy', true, text)
  }
}
